import React from 'react';
import PropTypes from 'prop-types';

import {currentResource, labels} from '../../../../../../util/utils';

import columns from './columns';

import CustomTable from '../../../../../CoreWrappers/CustomTable';

const UnmappedRisksTable = ({data, tab}) => {
	if (!data) return false;

	const props = {
		id: 'unmappedRisksTable',
		data,
		columns: columns(currentResource.unmappedRisksTableColumnLabels, tab),
		labels: {
			emptyMessage: labels.noDataFound,
			show: labels.show
		},
		enableBodyScroll: true
	};

	return <CustomTable {...props} />;
};

UnmappedRisksTable.propTypes = {};

export default UnmappedRisksTable;
